import {
  ProductMedia,
  productMediaFromResponse,
} from '../interfaces/Product/ProductMedia';
import api from './Api';
import { productsAdminApiPrefix } from './Product';
import { ProductMediaOptions } from '../interfaces/Product/ProductMediaOptions';
import { base64ToFile } from '../utils/Encoding';
import { ProductEnhancementPreset } from '../interfaces/Product/ProductEnhancementPreset';

export const getProductMedia = async (id: number): Promise<ProductMedia> => {
  const response = await api.get(`${productsAdminApiPrefix}/media/${id}`);

  return productMediaFromResponse(response.data?.data);
};

export const enhanceProductImage = async (
  image: File,
  preset: ProductEnhancementPreset,
  additionalPrompt: string,
): Promise<File | undefined> => {
  const bodyFormData = new FormData();
  bodyFormData.append('image', image);
  bodyFormData.append('preset', preset);
  bodyFormData.append('additional-prompt', additionalPrompt);

  const response = await api.post(
    `${productsAdminApiPrefix}/media/enhance`,
    bodyFormData,
  );

  const bytes = response.data?.data as string;
  if (!bytes) return undefined;

  return base64ToFile(bytes, image.name);
};

export const updateProductMedia = async (
  id: number,
  media: ProductMediaOptions,
): Promise<ProductMedia> => {
  const bodyFormData = new FormData();

  if (media.image) {
    bodyFormData.append('image', media.image);
  }

  if (media.eraseImage) {
    bodyFormData.append('erase-image', '1');
  }

  if (Number.isFinite(media.index)) {
    bodyFormData.append('index', media.index!.toString());
  }

  if (media.videoURL) {
    bodyFormData.append('video-url', media.videoURL);
  }

  if (media.eraseVideo) {
    bodyFormData.append('erase-video', '1');
  }

  const response = await api.put(
    `${productsAdminApiPrefix}/media/${id}`,
    bodyFormData,
  );

  return productMediaFromResponse(response.data?.data);
};
